(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mt-collection-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mt-collection-description')) {
    customElements.define('mt-collection-description', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
      }

      initialize() {
        if (!this.isConnected) return;
        if (!this.ready) {
          this.content = this.querySelector('.mt-collection-description__content');
          this.button = this.querySelector('.mt-collection-description__toggle');
          if (!this.content || !this.button) return;
          const first = this.content.firstElementChild;
          if (first && /^H[1-6]$/.test(first.tagName)) {
            first.classList.add('mt-collection-description__heading');
            this.insertBefore(first, this.content);
          }
          this.preview = document.createElement('p');
          this.preview.className = 'mt-collection-description__preview';
          const text = Array.from(this.content.childNodes)
            .map(node => node.textContent.trim()).filter(Boolean).join(' ');
          this.preview.textContent = text.replace(/\s+/g, ' ');
          this.preview.hidden = true;
          this.insertBefore(this.preview, this.content);
          this.expanded = false;
          this.button.addEventListener('click', () => {
            this.expanded = !this.expanded;
            this.update();
            if (!this.expanded && this.getBoundingClientRect().top < 0) {
              this.scrollIntoView({ block: 'center', behavior: 'instant' });
            }
          });
          this.ready = true;
        }
        this.update();
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.lastWidth) {
            this.lastWidth = width;
            this.update();
          }
        });
        this.observer.observe(this);
        document.fonts.ready.then(() => {
          if (this.isConnected) this.update();
        });
      }

      update() {
        this.content.hidden = false;
        const lineHeight = parseFloat(getComputedStyle(this).lineHeight);
        const maxHeight = lineHeight * Number(this.dataset.lines || 2);
        const needsToggle = this.content.getBoundingClientRect().height > maxHeight + 2;
        this.button.hidden = !needsToggle;
        this.preview.hidden = !needsToggle || this.expanded;
        this.content.hidden = needsToggle && !this.expanded;
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.button.querySelector('[data-more]').hidden = this.expanded;
        this.button.querySelector('[data-less]').hidden = !this.expanded;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
